module.exports = __webpack_public_path__ + "react-public-static/media/background-icons.4deb0704.svg";